import ElementTooltipContainer from '~/components/Tooltip/ElementTooltipContainer';
import connectTooltip from './connectTooltip';

export default connectTooltip(ElementTooltipContainer);